import React, { useState, Fragment, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Spinner from "../layout/Spinner";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getStates, getDistrict, getBlockDetails } from "../../actions/area";
import Pagination from "../layout/Pagination";
import {
  getBatchOfDistrict,
  getAllBatchesDropdown,
  getTallyReportofAllBatches,
} from "../../actions/shg";
import { CSVLink } from "react-csv";
import { useLocation } from "react-router-dom";

const TallyReport = ({
  auth: { isAuthenticated, user, users },
  area: { statesData, activeDistrict, getBlock },
  shg: {
    Tallyreportofbatches,
  loadStatus,
    batchOfDistrict,
    ASSAAssetAndLiability,
    excessPayment,
    surplusDeficit,
  },

  getStates,
  getDistrict,
  getBatchOfDistrict,
  getBlockDetails,
  getTallyReportofAllBatches,
}) => {

  // useEffect(() => {
  //   getStates();
  // }, [getStates]);


  useEffect(() => {
    getTallyReportofAllBatches();

  }, [getTallyReportofAllBatches]);
 useEffect(() => { }, [loadStatus]);


 
  let loggedUserInstitutionData = JSON.parse(
    localStorage.getItem("loggedUserInstitutionData"),
  );

  const allPermission = [];
  loggedUserInstitutionData &&
    loggedUserInstitutionData.permission &&
    loggedUserInstitutionData.permission.map((permission) =>
      allPermission.push(permission.permissionName),
    );


  let selBatchDetails = JSON.parse(localStorage.getItem("filterOption"));
  let selTallyDetails;
  if (selBatchDetails && selBatchDetails != undefined) {
    selTallyDetails = selBatchDetails;
  }
  else {
    localStorage.removeItem("filterOption");
  }

  useEffect(() => {
    getStates();
  }, []);







  ////////////////State DropDown////////////////
  const allstates = [];
  statesData.map((state) =>
    allstates.push({
      sId: state._id,
      label: state.stateName,
      value: state.stateName,
    }),
  );
  const [state, getStateData] = useState(
    selTallyDetails &&
    selTallyDetails.stateInfo && {
      sId: selTallyDetails.stateInfo,
      label: selTallyDetails.stateName,
      value: selTallyDetails.stateName,
    }
  );

  const [stateId, setStateID] = useState();
  const [stateName, setStateName] = useState();
  const onStateChange = (e) => {
    var stateId = "";
    var stateName = "";
    getStateData(e);

    stateId = e.sId;
    stateName = e.value;

    setStateID(stateId);
    setStateName(stateName);
    let stateVal = {
      stateInfo: stateId,
      stateName: stateName
    };
    localStorage.setItem("filteredData", JSON.stringify(stateVal));

    getDistrict(stateVal);
    getdistrictData("");
    getBatchOfDistrict("");
    getTallyReportofAllBatches(stateVal);
    getbatchesData("");
    setBlock("");
    setCurrentData(1)
    localStorage.setItem("PageIndex", 1);
  };






  //////////////District DropDown/////////////////

  const alldistrict = [];

  activeDistrict.map((district) =>
    alldistrict.push({
      districtId: district._id,
      label: district.districtName,
      value: district.districtName,
    }),
  );
  const [district, getdistrictData] = useState(
    selTallyDetails &&
    selTallyDetails.districtId && {
      sId: selTallyDetails.districtId,
      label: selTallyDetails.districtName,
      value: selTallyDetails.districtName,
    }
  );

  const [districtId, setdistrictID] = useState();
  const [districtName, setdistrictName] = useState();

  const ondistrictChange = (e) => {
    var districtId = "";
    var districtName = "";
    getdistrictData(e);
    getBlockDetails({ districtIdVal: e.districtId });
    districtId = e.districtId;
    districtName = e.value;
    setdistrictID(districtId);
    setdistrictName(districtName);
    var filterData = {
      districtId: districtId,
      districtName: e.value,

    };
    localStorage.setItem("filteredData", JSON.stringify(filterData));

    getBatchOfDistrict(filterData);
    getTallyReportofAllBatches(filterData);
      getbatchesData("");
    setBlock("");
    setCurrentData(1);
    localStorage.setItem("PageIndex", 1);

  };
  /////////////////Block DropDown///////////////////

  const allBlocks = [];
  getBlock &&
    getBlock.map((block) =>
      allBlocks.push({
        label: block.blockName,
        value: block._id,
      }),
    );

  const [block, setBlock] = useState(
    selTallyDetails &&
    selTallyDetails.blockId && {
      label: selTallyDetails.blockName,
      value: selTallyDetails.blockName,
    }
  );
  const onBlockChange = (e) => {
    // console.log("block value", e);
    setBlock(e);
    getBatchOfDistrict({
      blockId: e.value,
    });
    let blockdata = {
      blockId: e.value,
      blockName: e.label
    }
   setCurrentData(1);
    getbatchesData("");
    localStorage.setItem("filteredData", JSON.stringify(blockdata));
    localStorage.setItem("PageIndex", 1);
    getTallyReportofAllBatches(blockdata)

  };
 const allbatchesList = [];
  batchOfDistrict.map((batches) =>
    allbatchesList.push({
      batchesId: batches._id,
      label: batches.batchName,
      value: batches.batchName,
    }),
  );

  const [batches, getbatchesData] = useState(
    selTallyDetails &&
    selTallyDetails.batchIdVal && {
      batchesId: selTallyDetails.batchIdVal,
      label: selTallyDetails.batchName,
      value: selTallyDetails.batchName,
    }
    
  );
  const onBatchChange = (e) => {
    getbatchesData(e);
    
    const changeData = {
      batchIdVal: e.batchesId,
      batchName: e.value,
    };
    
    setCurrentData(1);
    localStorage.setItem("filteredData", JSON.stringify(changeData));
    localStorage.setItem("PageIndex", 1);
    getTallyReportofAllBatches(changeData)
  };

const onClickReset = () => {
    getStates(null);
    getDistrict(null);
    getStateData(null);
    getdistrictData(null);
    getBatchOfDistrict(null);
    getbatchesData(null);
    getBlockDetails(null);
    setBlock(null);
    localStorage.removeItem("filteredData");
    localStorage.removeItem("filterOption");
    getTallyReportofAllBatches(null);
    setCurrentData(1);
    localStorage.setItem("PageIndex", 1);

  };

  // surplu/deficit data

  const Tallysurplusdeficit = (batchReport) => {
    const income =
      Number(batchReport.batchInterestPaid) +
      Number(batchReport.batchOtherLoanInterestShg) +
      Number(batchReport.batchSubAmt) +
      Number(batchReport.subsidyReceived) +
      Number(batchReport.batchOtherContribution) +
      Number(batchReport.batchOtherIncome) +
      Number(batchReport.bankInterest) +
      Number(batchReport.seedMoney);

    const expense =
      Number(batchReport.batchOtherLoanInterestDonor) +
      Number(batchReport.bankCommission) +
      Number(batchReport.donationToOutsider) +
      Number(batchReport.stationaryExpenses) +
      Number(batchReport.otherExpenses) +
      Number(batchReport.travellingExpenses) +
      Number(batchReport.batchDividendDistributed);

    const diff = income - expense;

    const diffdata = Math.round(diff * 100) / 100;
    return diffdata;
    // if (diffdata < 0) {
    //   return <>({diffdata})</>
    // }
    // else {
    //   return diffdata;
    // }

  }


  const surplusdeficit = (batchReport) => {
    const income =
      Number(batchReport.batchInterestPaid) +
      Number(batchReport.batchOtherLoanInterestShg) +
      Number(batchReport.batchSubAmt) +
      Number(batchReport.subsidyReceived) +
      Number(batchReport.batchOtherContribution) +
      Number(batchReport.batchOtherIncome) +
      Number(batchReport.bankInterest) +
      Number(batchReport.seedMoney);

    const expense =
      Number(batchReport.batchOtherLoanInterestDonor) +
      Number(batchReport.bankCommission) +
      Number(batchReport.donationToOutsider) +
      Number(batchReport.stationaryExpenses) +
      Number(batchReport.otherExpenses) +
      Number(batchReport.travellingExpenses) +
      Number(batchReport.batchDividendDistributed);

    const diff = income - expense;

    return diff < 0
      ? { surplus: 0, deficit: diff }
      : { surplus: diff, deficit: 0 };
  };


  // batch income

  const incomeTotal = (batchReport) => {
    const baseIncome =
      Number(batchReport.batchInterestPaid) +
      Number(batchReport.batchOtherLoanInterestShg) +
      Number(batchReport.batchSubAmt) +
      Number(batchReport.subsidyReceived) +
      Number(batchReport.batchOtherContribution) +
      Number(batchReport.batchOtherIncome) +
      Number(batchReport.bankInterest) +
      Number(batchReport.seedMoney);

    const { surplus, deficit } = surplusdeficit(batchReport);
    const Surplusfinaldata = baseIncome + Math.abs(deficit);


    return Math.round(Surplusfinaldata * 100) / 100;
  };

  // batch expense
  const ExpenseTotal = (batchReport) => {
    const baseExpense =
      Number(batchReport.batchOtherLoanInterestDonor) +
      Number(batchReport.bankCommission) +
      Number(batchReport.donationToOutsider) +
      Number(batchReport.stationaryExpenses) +
      Number(batchReport.otherExpenses) +
      Number(batchReport.travellingExpenses) +
      Number(batchReport.batchDividendDistributed)
    const { surplus, deficit } = surplusdeficit(batchReport);
    const Expensefinaldata = baseExpense + Math.abs(surplus);


    return Math.round(Expensefinaldata * 100) / 100;
  };




  // asset

  const getBankBalance = (data) => {
    return (
      Number(data.sumOfDeposit) +
      Number(data.sumOfInt) -
      Number(data.sumOfWithdr) -
      Number(data.sumOfComm)
    );
  };

  const getIL = (data) => {
    return Number(data.batchLoanAmt) - Number(data.batchLoanPaid);
  };

  const getOLPaid = (data) => {
    if (Number(data.otherLoanSanctionedToMember) - Number(data.otherLoanPaidToShg) < 0) {
      return 0
    } else {

      return (
        Number(data.otherLoanSanctionedToMember) - Number(data.otherLoanPaidToShg)
      );
    }
  };

  const getSD = (data) => {
    return Number(data.sdUnionToSHG) - Number(data.sdSHGToUnion);
  };
  const assetTotal = (assetTotal) => {
    const Assetfinaldata = getBankBalance(assetTotal) +
      Number(assetTotal.cashInHand) +
      getIL(assetTotal) +
      getOLPaid(assetTotal) +
      getSD(assetTotal)

    return Math.round(Assetfinaldata * 100) / 100;
    // return Math.floor(Assetfinaldata * 100) / 100;
  };




  // liability
  const getAllOthLoan = (data) => {
    return (
      Number(data.otherLoanSanctionedToShg) - Number(data.otherLoanPaidToDonor)
    );
  };

  const getMemSvgAmt = (data) => {
    return Number(data.batchSavingAmt) - Number(data.batchSavingWithdrawals);
  };

  const getSDMem = (data) => {
    return (
      Number(data.batchSecurityDepositMemToShg) -
      Number(data.batchSecurityDeposit)
    );
  };
  const liabilityTotal = (liabilityTotal) => {
    const baseliability =
      getAllOthLoan(liabilityTotal) +
      getMemSvgAmt(liabilityTotal) +
      getSDMem(liabilityTotal)
    const { surplus, deficit } = surplusdeficit(liabilityTotal);

    const Liabilityfinaldata = baseliability + Math.abs(surplus) - Math.abs(deficit);
    return Math.round(Liabilityfinaldata * 100) / 100;
  };






  if (JSON.parse(localStorage.getItem("PageIndex")) === null) {
    localStorage.setItem("PageIndex", 1);
  }

  //pagination code
  const [currentData, setCurrentData] = useState(
    JSON.parse(localStorage.getItem("PageIndex"))
  );
  const [dataPerPage] = useState(10);
  //Get Current Data
  const indexOfLastData = currentData * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentDatas =
    Tallyreportofbatches && Tallyreportofbatches.slice(indexOfFirstData, indexOfLastData);
  if (currentDatas && currentDatas.length < 10) {
    localStorage.setItem("PageIndex", 1);
  }
  //change page
  const paginate = (nmbr) => {
    localStorage.setItem("PageIndex", nmbr);
    setCurrentData(nmbr);
  };

  // csv data

  const meassge = "message data";

  const csvData = [
    [
      "Sl no",
      "Batch Name",
      "Income",
      "Expenses",
      "Surplus/Deficit",
      "Asset",
      "Liability",
      "Tally/Not Tally",

    ],
  ];
  Tallyreportofbatches && Tallyreportofbatches.map((tallyreport, idx) => {
    return csvData.push([
      idx + 1,

      tallyreport.batchName,
      incomeTotal(tallyreport),
      ExpenseTotal(tallyreport),
      Tallysurplusdeficit(tallyreport),
      assetTotal(tallyreport),
      liabilityTotal(tallyreport),
      incomeTotal(tallyreport) === ExpenseTotal(tallyreport)
        ? (assetTotal(tallyreport) === liabilityTotal(tallyreport)
          ?
          "Tallied " : "Not Tallied")
        : "Not Tallied"
    ])
  })


  return !isAuthenticated || !user || !users ? (
    <Spinner />
  ) : (
    <Fragment>
      {loadStatus ?
        (
          <Spinner />
        )
        :
        (<div className="container container_align ">
          <div className="col-lg-11 col-md-11 col-sm-11 col-11">
            <h2 className="heading_color">Tally Summary Report</h2>
            <hr />
          </div>
          <section className="sub_reg">
            <div className="row col-lg-11 col-md-11 col-sm-11 col-11 no_padding">
              <>
                <div className="col-lg-3 col-md-5 col-sm-4 col-11 mt-1" >
                  <Select
                    name="stateName"
                    options={allstates}
                    isSearchable={true}
                    value={state}
                    placeholder="Select State"
                    onChange={(e) => onStateChange(e)}
                    className="selectdropdownIndex"

                  />
                </div>
                <div className="col-lg-2 col-md-5 col-sm-4 col-11 mt-1">
                  <Select
                    name="districtName"
                    options={alldistrict}
                    isSearchable={true}
                    value={district}
                    placeholder="Select District"
                    onChange={(e) => ondistrictChange(e)}
                  />
                </div>
                {allPermission && allPermission.includes("Blockwise") && (
                  <div className="col-lg-2 col-md-5 col-sm-4 col-11 mt-1">
                    <Select
                      name="blockName"
                      options={allBlocks}
                      isSearchable={true}
                      value={block}
                      placeholder="Select Block"
                      onChange={(e) => onBlockChange(e)}
                    />
                  </div>
                )}
                <div className="col-lg-3 col-md-5 col-sm-4 col-3 mt-1">
                   <Select
                      name="batchName"
                      options={allbatchesList}
                      isSearchable={true}
                      value={batches}
                      placeholder="Select SHG"
                      onChange={(e) => onBatchChange(e)}
                    />

                </div>
              </>
            </div>

            <div className="row col-lg-11 col-md-11 col-sm-11 col-11 no_padding mt-2">

              <div className="col-lg-4 col-md-8 col-sm-4 col-11 "></div>

              <div className="col-lg-8 col-md-4 col-sm-4 col-11 py-3">
                <Link to="/all-reports" onClick={() => {
                  localStorage.removeItem("filteredData");
                  localStorage.removeItem("filterOption");
                  localStorage.removeItem("batchData");
                  localStorage.removeItem("PageIndex");
                }}>
                  <img
                    className="img_icon_size log float-right ml-3"
                    src={require("../../static/images/back.png")}
                    alt="Back"
                    title="Back"
                  />
                </Link>
                <img
                  className="img_icon_size log float-right ml-3"
                  onClick={() => onClickReset()}
                  src={require("../../static/images/refresh-icon.png")}
                  alt="refresh"
                  title="Refresh"
                />


                <CSVLink data={csvData} filename="TallySummaryReport.csv">
                  <img
                    className="img_icon_size log float-right ml-4"
                    src={require("../../static/images/ExcelIcon.png")}
                    alt="Excel-Export"
                    title="Excel-Export"
                  />
                </CSVLink>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-11 col-md-11 col-sm-11 col-11 text-center ">
                <section className="body">
                  <div className=" body-inner no-padding  table-container ">
                    <table
                      className="table table-bordered table-striped table-hover"
                      id="datatable2"
                    >
                      <thead>
                        <tr>
                          <th className="sticky-column">Sl No</th>
                          <th>Batch Name</th>
                          <th>Income</th>
                          <th>Expense</th>
                          <th>Surplus/Deficit</th>
                          <th>Asset</th>
                          <th>Liability</th>
                          <th>Tally/Not Tally</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentDatas && currentDatas.map((batchReport, idx) => {
                          return (
                            <tr key={idx} >

                              <td className="sticky-column">
                                {(currentData - 1) * dataPerPage + idx + 1}
                              </td>
                              <td>{batchReport.batchName}</td>
                              <td>{incomeTotal(batchReport)}</td>
                              <td>{ExpenseTotal(batchReport)}</td>
                              <td>{Tallysurplusdeficit(batchReport) < 0 ? (<>({Tallysurplusdeficit(batchReport)})</>):(<>{Tallysurplusdeficit(batchReport)}</>) }</td>
                              <td>{assetTotal(batchReport)}</td>
                              <td>{liabilityTotal(batchReport)}</td>


                              {incomeTotal(batchReport) === ExpenseTotal(batchReport)
                                ? (assetTotal(batchReport) === liabilityTotal(batchReport)
                                  ?
                                  <td style={{ backgroundColor: "rgba(215, 244, 222)", color: "#095A4A" }}>
                                    Tallied</td> : <td style={{ backgroundColor: "rgba(255, 200, 158)", color: "#DF6100" }}>
                                    <Link to="/AssetsandLiabiliyTallyReport" onClick={() => { localStorage.setItem("batchData", JSON.stringify(batchReport._id)) }} className="btnLink">Not Tallied</Link></td>)
                                : <td style={{ backgroundColor: "orange" }}>
                                  <Link to="/incomeexpensetallyreport" className="btnLink">Not Tallied</Link></td>}
                            </tr>
                          );
                        })}

                      </tbody>
                    </table>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-11 col-11 no_padding">
                    {Tallyreportofbatches && Tallyreportofbatches.length !== 0 ? (
                      <Pagination
                        dataPerPage={dataPerPage}
                        totalData={Tallyreportofbatches.length}
                        paginate={paginate}
                        currentPage={currentData}
                      />
                    ) : (
                      <Fragment />
                    )}
                  </div>
                </section>
              </div>
            </div>
          </section>
        </div>

        )}



    </Fragment>

  )

}
TallyReport.prototypes = {
  auth: PropTypes.object.isRequired,
  area: PropTypes.object.isRequired,
  getAllBatchesDropdown: PropTypes.func.isRequired,

};
const mapStateToProps = (state) => ({
  auth: state.auth,
  area: state.area,
  shg: state.shg,
});
export default connect(mapStateToProps, {
  getStates,
  getDistrict,
  getBatchOfDistrict,
  getBlockDetails,
  getAllBatchesDropdown,

  getTallyReportofAllBatches,
  

})(TallyReport);
